module.exports = __webpack_public_path__ + "img/malcom-x.1cf62c38.png";